import React from "react";
import "./Contact_Banner.css";
const Contact_Banner = () => {
  return (
    <div className="Contact-Banner">
    <div className="ImageContainer">
      <div className="overlay"></div>

        <div className="img_holder">
          <img
            src="/assets/images/contact-banner.png"
            alt="Banner"
            className="Contact_Banner_img"
          />
        </div>
    </div>
    </div>
  );
};
export default Contact_Banner;
